import * as React from "react";
import {
    Avatar, Badge, Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    IconButton,
    LinearProgress,  Stack,
    Typography,
} from "@mui/material";
import { LinearProgressProps } from '@mui/material/LinearProgress';
import {red,green,yellow,blue,lightBlue,grey} from "@mui/material/colors";
import DeleteIcon from '@mui/icons-material/Delete';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import CheckIcon from '@mui/icons-material/Check';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import ComputerIcon from '@mui/icons-material/Computer';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';
import ErrorIcon from '@mui/icons-material/Error';
import SwitchVideoIcon from '@mui/icons-material/SwitchVideo';
import ReplayIcon from '@mui/icons-material/Replay';

import {useContext, useEffect, useState,useRef} from "react";
import {IApplianceStatus, IDPoolContext,identityServer,apiVersion} from "../Context/IDContext";
import axios from "axios";


const APPLIANCE_STATUS_UKNOWN = -1
const APPLIANCE_STATUS_WAITING = 0
const APPLIANCE_STATUS_PROVISION = 1
const APPLIANCE_STATUS_PROVISION_SUCCESS = 2
const APPLIANCE_STATUS_PROVISION_ERROR = 3
const APPLIANCE_STATUS_BURNIN = 4
const APPLIANCE_STATUS_BURNIN_ERROR = 5
const APPLIANCE_STATUS_BURNIN_SUCCESS = 6


interface BurnInMessage {
    temp: number;
    load: number;
    decode: number;
    transcode: number;
    errors: number;
    testLength: number;
}
const EmptyBurnInMessage = { temp:0,load:0,decode:0,transcode:0,errors:0,testLength:1,burnInComplete:false}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

function runCommand(status:IApplianceStatus,command:string) {
    axios.post(identityServer+"/api/"+apiVersion+"/appliance/command/"+status.macAddress+"/"+command,{
        applianceStatus:status
    }).then(response => {
        console.log(response)
    }).catch(ex => {
        console.log(ex)
    })
}


function ActionIcon(props: {status:IApplianceStatus}) {
    const [status, changeStatus] = useState(props.status);
    const [disabled,disableButton] = useState(false)

    useEffect(() => {
        changeStatus(props.status);
        disableButton(false);
    }, [props.status]);

    if (!disabled) {
        if (status.deviceStatus === APPLIANCE_STATUS_PROVISION_SUCCESS) {
            return (<IconButton aria-label="settings" onClick={(e) => {
                    disableButton(true)
                    runCommand(status, "burnin")
            }}>
                <FireplaceIcon/>
            </IconButton>)
        } else if (status.deviceStatus === APPLIANCE_STATUS_PROVISION_ERROR) {
            return (<IconButton aria-label="settings" onClick={(e) => {
                    disableButton(true)
                    runCommand(status, "retry")
            }}>

                <ReplayIcon/>
            </IconButton>)
        }
    }
    return <></>
}


function StatusIcon(props: {status:IApplianceStatus}) {
    let statusIcon = APPLIANCE_STATUS_UKNOWN
    const [status, changeStatus] = useState(props.status);

    useEffect(() => {
        changeStatus(props.status);
    }, [props.status]);

    statusIcon = status.deviceStatus

    switch (statusIcon) {
        case APPLIANCE_STATUS_PROVISION_ERROR:
            return  <Avatar sx={{ bgcolor: red[500] }} aria-label="failed"><CancelPresentationIcon /></Avatar>
        case APPLIANCE_STATUS_PROVISION_SUCCESS:
            return <Avatar sx={{ bgcolor: green[500] }} aria-label="success"><CheckIcon /></Avatar>
        case APPLIANCE_STATUS_PROVISION:
            return <Avatar sx={{ bgcolor: yellow[500] }} aria-label="inprogress"><AppRegistrationIcon /></Avatar>
        case APPLIANCE_STATUS_BURNIN:
            return <Avatar sx={{ bgcolor: yellow[500] }} aria-label="inprogress"><FireplaceIcon /></Avatar>
        case APPLIANCE_STATUS_BURNIN_ERROR:
            return  <Avatar sx={{ bgcolor: red[500] }} aria-label="failed"><CancelPresentationIcon /></Avatar>
        case APPLIANCE_STATUS_BURNIN_SUCCESS:
            return <Avatar sx={{ bgcolor: green[500] }} aria-label="success"><CheckIcon /></Avatar>
        default:
            return <Avatar sx={{ bgcolor: red[500] }} aria-label="unknown"><QuestionMarkIcon /></Avatar>
    }
}

function LogMessage(props: {status:IApplianceStatus}) {
    const [status, changeStatus] = useState(props.status);

    useEffect(() => {
        changeStatus(props.status);
    }, [props.status]);

    if (status) {
        let message: BurnInMessage =  EmptyBurnInMessage
        let progress = 0
        let burnInHeader = ""
        if (status.deviceStatus === APPLIANCE_STATUS_BURNIN  ) {
            try { message = JSON.parse(status.logMessage) } catch (e) { }
            progress = (status.elapsedTime / message.testLength) * 100
        } else if (status.deviceStatus ===  APPLIANCE_STATUS_BURNIN_SUCCESS ) {
            progress = 0
            try { message = JSON.parse(status.logMessage) } catch (e) { }
            burnInHeader = "Burn In Completed"
        } else if (status.deviceStatus === APPLIANCE_STATUS_BURNIN_ERROR) {
            burnInHeader = "Burn In Failed"
            try { message = JSON.parse(status.logMessage) } catch (e) { }
            progress = 0
        } else {
            return (<>{status.logMessage}</>)
        }

        return (
            <Stack key={status.macAddress} spacing={5}>
                {burnInHeader != "" ? <Typography variant="h5">{burnInHeader}</Typography> :
                    <LinearProgressWithLabel variant="determinate" value={progress}/>}
                <Stack spacing={4} direction="row" sx={{color: 'action.active'}}>
                    <Badge badgeContent={message.load} color="primary">
                        <ComputerIcon color="action"/>
                    </Badge>
                    <Badge badgeContent={message.temp} color="primary">
                        <DeviceThermostatIcon color="action"/>
                    </Badge>
                    <Badge badgeContent={message.decode} color="primary">
                        <VideoCameraBackIcon color="action"/>
                    </Badge>
                    <Badge badgeContent={message.transcode} color="primary">
                        <SwitchVideoIcon color="action"/>
                    </Badge>
                    <Badge badgeContent={message.errors} color="primary">
                        <ErrorIcon color="action"/>
                    </Badge>
                </Stack>
            </Stack>
        )
    }
    return (<></>)
}

function DashboardCards(props: { applianceStatus: IApplianceStatus[] | undefined } ) {
    const [applianceStatus, changeStatus] = useState(props.applianceStatus);

    useEffect(() => {
        changeStatus(props.applianceStatus);
    }, [props.applianceStatus]);

    if (applianceStatus)
        return <> {applianceStatus.map(status => {

            let lastUpdate= new Date(status.lastUpdate).toLocaleString()
            return (
                <Grid item xs key={status.macAddress}>
                    <Card variant="outlined" sx={{maxWidth: 345, minWidth: 345}}>
                        <CardHeader
                            avatar={<StatusIcon status={status} />}
                            action={<ActionIcon status={status} />}
                            title={status.serial}
                            subheader={lastUpdate}
                        />
                        <CardContent>
                            <Typography variant="body2" color="text.secondary">
                                <LogMessage status={status} />
                            </Typography>
                        </CardContent>
                        <CardContent>
                            <Typography variant="subtitle2">{status.macAddress} | {status.ipAddress}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )
        })}</>
    return(<></>)
}

export function Dashboard() {
    const {
        applianceStatus,
        loading,
        error } = useContext(IDPoolContext)
    if (!applianceStatus) {
        return (
            <Grid padding={4} container spacing={2}>
                <Grid item xs={3}></Grid>
                <Grid item xs={6}>
                    <Typography variant="h4" align="center">Ready to Provision</Typography>
                </Grid>
                <Grid item xs={3}></Grid>
            </Grid>)
    }
    return (
        <Grid container spacing={3}>
                <DashboardCards applianceStatus={applianceStatus} />
        </Grid>

    )

}


